import { ApiBaseService, ApiV2Service } from './api.base.service';
import { User } from '../types';

export class LoginService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async login(credentials: object): Promise<{ token: string } | null> {
    try {
      return this.api.post('auth/login', credentials);
    } catch (e) {
      return null;
    }
  }

  public async me(): Promise<User> {
    return this.api.get('user/me');
  }

  public async registerTOTP(password: string): Promise<{totpSecret: string, totpUri: string}> {
    return this.api.put('user/me/registerTOTP', { password });
  }

  public async enableTOTP(totpCode: string): Promise<{recoveryCode: string}> {
    return this.api.put('user/me/enableTOTP', { totpCode });
  }

  public async disableTOTP(password: string): Promise<void> {
    return this.api.put('user/me/disableTOTP', { password });
  }

  public async updateMe(payload: object): Promise<User> {
    return this.api.put(`user/me`, payload);
  }

  public async getPermissions(orgId: number): Promise<string[]> {
    return this.api.get(`user/permissions?orgId=${orgId}`);
  }
}

export default new LoginService();
